import PropTypes from 'prop-types';
export const heroPropTypes = {
  actions: PropTypes.shape({
    picture: PropTypes.shape({
      href: PropTypes.string
    })
  })
};